import jwtDecode from 'jwt-decode'

import { store } from '@app/common/store'

import { refreshSession } from './refreshSession'
import { AuthSelectors } from './selectors'

const REFRESH_LEEWAY_MS = 60 * 1000

function getTokenExpiry(token?: string | null): number | undefined {
  if (!token) {
    return undefined
  }

  try {
    return jwtDecode<{ exp?: number }>(token).exp
  } catch {
    return undefined
  }
}

export function isTokenExpired(exp?: number) {
  return Boolean(exp && exp * 1000 <= Date.now())
}

export function isTokenExpiringSoon(exp?: number) {
  return Boolean(exp && exp * 1000 - Date.now() <= REFRESH_LEEWAY_MS)
}

export async function resolveAuthToken(): Promise<string | undefined> {
  const state = store.getState()
  const token = AuthSelectors.getToken(state)
  const refreshToken = AuthSelectors.getRefreshToken(state)

  if (!token) {
    return undefined
  }

  const exp = getTokenExpiry(token)
  const shouldRefresh = isTokenExpired(exp) || isTokenExpiringSoon(exp)

  if (refreshToken && shouldRefresh) {
    const refreshedToken = await refreshSession()

    if (refreshedToken) {
      return refreshedToken
    }
  }

  return token
}

export async function requireAuthToken(): Promise<string> {
  const token = await resolveAuthToken()

  if (!token) {
    throw new Error('Unauthorized')
  }

  return token
}
